<template>
  <form>
    <div class="field">
      <generic-dropdown
        :title="$t('human task')"
        :placeholder="$t('select one')"
        :is_multiple="false"
        url="/ngine/composer/human-task/catalog"
        name_field="name"
        value_field="human_task_id"
        :extra_data="{ process_uuid: $route.params.id }"
        @selected="set_human_task"
        :add_new="true"
        ref="human_task_dropdown"
        @add_new="new_human_task"
      />
    </div>
    <!-- <div class="field">
      <label class="label">{{ $t("human task") }}</label>
      <div class="control">
        <input
          type="text"
          class="input"
          v-model="meta.human_task_id"
          :placeholder="$t('name')"
        />
      </div>
    </div> -->
  </form>
</template>
<script>
import {
  put,
  error_message,
  get,
  input_alert,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
  format_currency,
  api_host,
} from "@/utils";

import GenericDropdown from "@/components/generic_dropdown/Index.vue";

export default {
  name: "StartEvent",
  props: {
    settings: Object,
    required: true,
  },
  components: {
    GenericDropdown,
  },
  data() {
    return {
      meta: {},
    };
  },
  methods: {
    get_data() {
      let v = this;
      return v.meta;
    },
    new_human_task() {
      let v = this;
      input_alert({
        title: v.$t("new human task"),
        input_label: v.$t("enter the name of the human task"),
        input: "text",
        showCancelButton: true,
      })
        .then((value) => {
          post("/ngine/composer/human-task", {
            process_uuid: v.$route.params.id,
            name: value,
          })
            .then((response) => {
              // success_message(v.$t("human task created"));
            })
            .catch((error) => {
              error_message(error);
            });
        })
        .catch((error) => {
          error_message(error);
        });
    },
    set_human_task(human_task) {
      let v = this;
      if (human_task) v.meta.human_task_id = human_task.human_task_id;
    },
    clear() {
      let v = this;
      v.meta = {};
      v.$refs.human_task_dropdown.clear();
    },
  },
  mounted() {
    let v = this;
    if (v.settings) {
      v.meta = { ...v.settings };

      if (v.meta.human_task_id)
        v.$refs.human_task_dropdown.set_value(v.meta.human_task_id);
    }
  },
  watch: {},
};
</script>
<style></style>
